import { render, staticRenderFns } from "./MenuScreen.vue?vue&type=template&id=614088a4&"
import script from "./MenuScreen.vue?vue&type=script&lang=js&"
export * from "./MenuScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports